// extracted by mini-css-extract-plugin
module.exports = {"welcome__text":"WelcomeText_welcome__text__rYGzp","connect":"WelcomeText_connect__38XRe","share":"WelcomeText_share__31M7R","cherish":"WelcomeText_cherish__1CAkF"};